<template>
  <footer class="bg-gray-200 px-4 shadow">
    <div
      class="flex flex-col md:flex-row items-center justify-between px-2 lg:px-20 py-2 space-y-2 md:space-y-0"
    >
      <div class="text-slate-900 font-semibold text-center text-xs md:text-base">
        {{
          $t("copyright-c-2024-subtitles-tech-company-s-l-all-rights-reserved", {
            year: currentYear,
          })
        }}
      </div>
      <div class="flex flex-row space-x-6 md:space-x-3 xl:space-x-6 text-xs md:text-base">
        <router-link to="/terms">
          <p
            :class="{ 'pl-10': locale === 'ar' }"
            class="text-slate-900 font-semibold text-center"
          >
            {{ $t("Termsofuse") }}
          </p>
        </router-link>
        <router-link to="/privacy-policy">
          <p class="text-slate-900 font-semibold text-center">
            {{ $t("privacy-policy") }}
          </p>
        </router-link>
        <router-link to="/cookies-policy">
          <p class="text-slate-900 font-semibold text-center">
            {{ $t('cookies-policy') }}
          </p>
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { locale } = useI18n();

const currentYear = new Date().getFullYear();
</script>
